<template>
<main class="bg-main lesson-exam">
  <contenthead :section="sectionData" :lesson="lessonData" :contentsData="contentsData"></contenthead>
  <section class="container">
    <examquestion v-if="examData.questions && step" :questions="examData.questions" :step="step" @finquiz="finQuiz" @passedquiz="passedQuiz" @scoreresult="scoreResult"></examquestion>

    <div class="row pd-lr-20" v-if="fin_quiz">
      <button type="button" class="button button-primary next" v-show="(score_result && score_result!='failure')" @click.prevent="completedSection">{{ $t('lesson.exam.button.next') }}</button>
      <button type="button" class="button undo" :class="(score_result && score_result=='failure') ? 'button-primary' : 'button-default'" @click.prevent="restartQuiz">{{ $t('lesson.question.button.over') }}</button>
      <button type="button" class="button button-default back" @click="goBack">{{ $t('lesson.exam.button.to_session') }}</button>
    </div>
    <div class="space-20"></div>
  </section>

</main>
</template>

<script>
import {api, appEnv} from "../../config";
import learningLog from '../../mixins/learning-log';
import status from '../../mixins/status';
import {mapState} from 'vuex'

import componentContentHead from '../shared/ContentHead.vue';
import LessonExamQuestion from './LessonExamQuestion.vue'

export default {
  name: 'LessonExam',
  mixins: [
    learningLog,
    status
  ],
  components: {
    'contenthead': componentContentHead,
    'examquestion': LessonExamQuestion,
  },
  data(){
    return{
      step: 'exam',
      fin_quiz: false,
      passed_quiz: false,
      score_result: null,
      contents_data: {}
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth
    }),
    sectionData() {
      return this.$store.getters.section_data;
    },
    lessonData() {
      return this.$store.getters.lesson_data;
    },
    contentsData() {
      return this.contents_data;
    },
    examData() {
      let contentKeys = Object.keys(this.$store.getters.lesson_content.exam.content)
      return (this.$store.getters.lesson_content.exam.content && contentKeys[0] in this.$store.getters.lesson_content.exam.content) ? this.$store.getters.lesson_content.exam.content[contentKeys[0]] : { questions: {}}
    },
  },
  
  created() {
    
    axios.get(api.contents, {
      params: {
        section_id: this.$store.getters.section_data.section_id,
        lesson_id: this.$store.getters.lesson_data.lesson_id,
        lesson_type: this.$store.getters.lesson_data.lesson_type
      }
    })
    .then((resp) => {
      this.contents_data = resp.data
    })
  },
  mounted() {
  },
  methods: {
    finQuiz() {
      this.fin_quiz = true
    },
    passedQuiz() {
      this.passed_quiz = true
    },
    scoreResult(result) {
      this.score_result = result
    },
    restartQuiz(){
      this.$router.go()
    },
    completedSection() {
      let self = this;
      const status_content = async function() {
        
        if (self.$store.getters.lesson_content[self.step].status != 'completed' || self.examData.status_exam != 'completed') {
          self.statusContent('completed', self.step, { content_data_type: 'exam', content_data_order: '1'});
        }
      }
      // Update status the first time and pass
      const status_lesson = async function() {
        if (self.passed_quiz && self.$store.getters.lesson_status == 'start') {
          self.statusLesson('completed');
        }
      }
      const status_section = async function() {
        if (self.passed_quiz && self.$store.getters.section_status == "start") {
          // 全Section内が終わったか？？
          let lastLessonData = self.$store.getters.lessons[self.$store.getters.lessons.length - 1]
          if(lastLessonData.lesson_id == self.$store.getters.lesson_data.lesson_id) {
            self.statusSection('completed');
          }
        }
      }

      // Run synchronously
      const processAll = async function() {
        await status_content()
        await status_lesson()
        await status_section()

        self.learningTempLog();
        // Update Log
        self.learningLog();
        
        axios.get(api.contents, {
          params: {
            section_id: self.$store.getters.section_data.section_id,
            lesson_id: self.$store.getters.lesson_data.lesson_id,
            lesson_type: self.$store.getters.lesson_data.lesson_type
          }
        })
        .then((resp) => {
          self.contents_data = resp.data
        })
        
        let currentLessonData = self.$store.getters.lesson_data
        
        let currentLessonsIdx = self.$store.getters.lessons.findIndex(item => {
          return (item.lesson_id == currentLessonData.lesson_id)
        });
        
        if(self.$store.getters.lessons.length > (currentLessonsIdx + 1)) {
          
          let nextLessonData = self.$store.getters.lessons[currentLessonsIdx + 1];
          
          self.$store.dispatch('showLoading', true);
          self.$store.dispatch('setLessonData', nextLessonData);
          self.$store.dispatch("setLessonStatus", nextLessonData.status);
          if(nextLessonData.status == 'incomplete' || nextLessonData.status == 'ready') {
            self.statusNextLesson(nextLessonData, 'start');
          }
          // Get the contents of a Session or Exam
          let lessonData = self.$store.getters.lesson_data
          axios.get(api.contents, {
            params: {
              section_id: self.$store.getters.section_data.section_id,
              lesson_id: self.$store.getters.lesson_data.lesson_id,
              lesson_type: self.$store.getters.lesson_data.lesson_type
            }
          })
          .then((resp) => {
            self.$store.dispatch('setLessonContent',  resp.data)
            self.$store.dispatch('showLoading', false)

            let push_val = { name: 'lesson.movie', params: { lesson_id: nextLessonData.lesson_id, content_order: 1 }}
            self.$router.push(push_val)
          })
          .catch(err => {
            self.$store.dispatch("showLoading", false);
          });
          
        } else {
          // 終わりなのでカテゴリリストへ
          self.$store.dispatch('showLoading', true)
          
          axios.get(api.lessons, {
            params: {
              section_id: self.$store.getters.section_data.section_id,
              section_status: self.$store.getters.section_status
            }
          })
          .then((resp) => {
            self.$store.dispatch('setLessons',  resp.data)
            self.$store.dispatch('showLoading', false)
            self.$router.push({ name: 'lesson.category', params: { category: self.$store.getters.section_data.section } })
          
          });
        }

        //
      }
      processAll()
    },
    goBack() {
      this.$router.push({ name: 'lesson.category', params: { category: this.$store.getters.section_data.section } });
    } 
  }
}
</script>

<style scoped>
</style>